// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__ADCS8","link":"styles_link__dgD_z"};